import { useEffect, useState } from "react";
import { fetchAllBlogPosts } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function HomeLatestPosts() {

    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAllBlogPosts()
        .then((data) => {
            setBlogPosts(Array.isArray(data) ? data : []);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    }, []);

    function formatDate(dateString) {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    }

    if (loading) return <p>Loading Latest Posts...</p>;
    
    return (
        <section className="section">
            <div className="section-header">
                <h2 className="section-title">Latest posts</h2>
                <Link to={'/blogs/latest'} className="see-more">See all</Link>
            </div>
            <div className="games-grid">
                {blogPosts.map((post) => (
                    <Link to={`/blog/${post.slug}`} key={post.id} className="game-card" style={{textDecoration: "none"}}>
                        <div className="game-image" style={{
                            background: "linear-gradient(45deg, #ff9a9e, #fecfef)",
                            backgroundImage: `url(${post.featured_image_url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                        }}>
                            <div
                                className="game-icon"
                                style={{
                                backgroundImage: `url(${post.avatar_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                }}
                            ></div>
                        </div>
                        <div className="game-info">
                            <div className="game-title">{post.title}</div>
                            <div className="game-developer">{post.category} • {post.views_count} Views</div>
                            <div className="game-rating">
                                <span className="rating-text">{formatDate(post.updated_at)}</span>
                            </div>
                        </div>
                    </Link>
                ))}
                
            </div>
        </section>
    );
}

export default HomeLatestPosts;